export default __webpack_public_path__ + "static/media/logo.48d55d85.png";